module.exports = __webpack_public_path__ + "img/banner-travel.be7e0dd7.png";